export interface URLKeys {
  query_id: string;
  site_id: string;
  study_id: string;
  personnel_id: string;
  file_id: string;
  milestone_id: string;
  code_list_code: string;
}

export type URLKey = keyof URLKeys;

export const urlKeys: URLKeys = {
  site_id: 'site_id',
  study_id: 'study_id',
  personnel_id: 'personnel_id',
  file_id: 'file_id',
  milestone_id: 'milestone_id',
  query_id: 'query_id',
  code_list_code: 'code_list_code'
};

export const endPoints = {
  isfLevel: { getAll: { url: `/isfLevel/binderViewer/getAll`, keepUnusedDataFor: 120 }, keepUnusedDataFor: 120 },
  masterDocument: { getAll: { url: `/masterDocument/getAll`, keepUnusedDataFor: 15 }, keepUnusedDataFor: 30 },
  study: {
    getAll: { url: '/study/getAll', keepUnusedDataFor: 30 },
    country: { url: '/study/country/{study_id}/select', keepUnusedDataFor: 30 },
    keepUnusedDataFor: 30
  },
  Utils: {
    selectStudies: '/utils/study/getAll',
    selectCountries: '/utils/country/getAll',
    selectSites: '/utils/site/getAll'
  },
  UserGroupManagement: {
    selectClientRoles: '/sysAdmin/groups/{group_name}/clientRoles/{client_name}'
  },
  DocumentsAccessUtils: {
    selectPermissions: '/utils/permissions'
  }
};
